var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgPen(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M5.431 16.922a4.083 4.083 0 011.032-1.735L20.713.938a3.027 3.027 0 014.265 0l1.828 1.829c.141.14.282.328.375.468a2.99 2.99 0 01-.375 3.797l-14.25 14.25c-.046.047-.14.094-.187.188a4.978 4.978 0 01-1.547.843l-3.656 1.079L5.15 24c-.375.094-.797 0-1.078-.328a.956.956 0 01-.281-1.078l.562-2.016 1.078-3.656zm2.157.656l-.328 1.078-.75 2.578 2.578-.75 1.078-.328a1.72 1.72 0 00.797-.468L21.697 8.953l-2.906-2.906L8.056 16.78c-.046 0-.046.047-.093.094-.188.188-.282.422-.375.703z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgPen);
export default ForwardRef;
